import {message, useIntl} from '@sail/intl';
import {view} from '@sail/ui';

const messages = {
  disclaimer: message({
    id: 'conversations_assistant.footer.disclaimer',
    description: 'Disclaimer text footer for the ai assistant',
    defaultMessage: 'AI may make mistakes. Verify important information.',
  }),
};

export const StripeAssistantDisclaimer = () => {
  const intl = useIntl();

  return (
    <view.div
      css={{
        stack: 'y',
        alignX: 'center',
        color: 'form.placeholder',
        font: 'label.small',
        flexGrow: 0,
      }}
    >
      <view.span>{intl.formatMessage(messages.disclaimer)}</view.span>
    </view.div>
  );
};
